import { render, staticRenderFns } from "./apdpsettle.vue?vue&type=template&id=2bb486ec"
import script from "./apdpsettle.vue?vue&type=script&lang=js"
export * from "./apdpsettle.vue?vue&type=script&lang=js"
import style0 from "./apdpsettle.vue?vue&type=style&index=0&id=2bb486ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports